import type { ScheduledChangeSummary } from '@/common/api/models';

const UPCOMING = new Set(['scheduled', 'draft_ready', 'applying']);
const RECENT = new Set(['live', 'failed', 'superseded', 'cancelled']);

export function splitScheduledChangeList(items: ScheduledChangeSummary[]) {
  const upcoming = items
    .filter((item) => UPCOMING.has(item.state))
    .sort((a, b) => new Date(a.goLiveAt ?? 0).getTime() - new Date(b.goLiveAt ?? 0).getTime());
  const recent = items
    .filter((item) => RECENT.has(item.state))
    .sort((a, b) => new Date(b.stateChangedAt).getTime() - new Date(a.stateChangedAt).getTime());
  return { upcoming, recent };
}
